import { render, staticRenderFns } from "./Historical_data2.vue?vue&type=template&id=5b03e0bd&scoped=true&"
import script from "./Historical_data2.vue?vue&type=script&lang=js&"
export * from "./Historical_data2.vue?vue&type=script&lang=js&"
import style0 from "./Historical_data2.vue?vue&type=style&index=0&id=5b03e0bd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b03e0bd",
  null
  
)

export default component.exports